module.exports = __webpack_public_path__ + "static/media/IMG_8530.25b9ce5e.png";